"use strict";

class SalesApplicationAddSaleDocumentUploadController {

    constructor($scope, SSHttpService, SSUtilService, $timeout, SSEoiService, SSAwsService, SSAlertService, SSAppService) {
        const self = this;

        self.$scope = $scope;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.$timeout = $timeout;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;        
        
        self.data = SHOWSUITE.data;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;

        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;
        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;        
        self.ASSET_MODEL_EOI_DOCUMENT = SHOWSUITE.ASSET_MODEL_EOI_DOCUMENT;
        self.ASSET_MODEL_EOI_INSTRUMENT = SHOWSUITE.ASSET_MODEL_EOI_INSTRUMENT;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;

        self.init();
    }

    init() {
        const self = this;

        self.allowEditBuyerDocuments = false;

        self.SSEoiService.documentUploadDirty = false;
    }

    uploadNewDocumentFiles(files, file_name, upload_type, document_kind, buyer) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'buyer': buyer,
            'callback': self.uploadNewDocCallback
        };

        self.file.callback(self);
    }

    uploadNewDocCallback(self) {
        self.uploadDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.buyer);
    }

    uploadDocumentFiles(files, file_name, upload_type, document_kind, buyer) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadDocument(response.config.data.key, file_name, upload_type, format_type, document_kind, buyer);
        });
    }

    _uploadDocument(file_uri, file_name, upload_type, format_type, document_kind, buyer) {
        const self = this;

        let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents';
        let params = {
            sale_buyer_id: buyer.saleBuyerId,
            name: file_name,
            type: upload_type,
            format: format_type,
            document_kind: document_kind,
            file_uri: file_uri
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            if (!buyer.hasOwnProperty("documents")) {
                buyer["documents"] = {};
            }
            buyer["documents"][document_kind] = response.data.sale_document;

            //To retrieve preview image
            url = 'sec/assets/presigned-url';
            params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': response.data.sale_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                buyer["documents"][document_kind]["show_file_url"] = response.data.presigned_url;
                self.SSEoiService.documentUploadDirty = true;
            });

        });
    }

    updateRelationshipSelector() {
        const self = this;
        
        self.$timeout(function() { 
            $(".dashboard-select#relationship").niceSelect('update');
        });
    }
    
    removeBuyerDocCallBack(self) {
        let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + self.file.documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File deleted successfully.');

            self.file.buyer["documents"][self.file.documentObj.document_kind] = null;
        });
    }

    removeBuyerDocument(documentObj, buyer) {
        const self = this;

        self.file = {
            'buyer': buyer,
            'documentObj': documentObj,
            'callback': self.removeBuyerDocCallBack
        };

        self.file.callback(self);
    }

    replaceBuyerDocCallBack(self) {
        //Delete existing file
        let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + self.file.documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.file.buyer["documents"][self.file.documentObj.document_kind] = null;
            self.uploadDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.buyer);
        });
    }

    replaceDocumentFiles(files, file_name, upload_type, document_kind, buyer, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'buyer': buyer,
            'documentObj': documentObj,
            'callback': self.replaceBuyerDocCallBack
        };

        self.file.callback(self);
    }

    uploadEOIDocument(files, instrument, upload_type, document_kind) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {                
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            instrument['file_uri'] = response.config.data.key;
            instrument.file = file;
            self.SSEoiService.documentUploadDirty = true;
        });
    }

    removeEOIDocument(documentObj, callback) {
        const self = this;

        if (documentObj.hasOwnProperty("id") && documentObj.id != null) {
            let url = 'sec/eois/' + self.SSEoiService.eoi.id + '/instruments/' + documentObj.id + '/delete';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.SSAlertService.success('Success!', 'File deleted successfully.');

                documentObj.id = null;
                documentObj.file_uri = null;
                documentObj["show_file_url"] = null;
                documentObj.file = null;

                callback;
            });
        } else {
            //Haven't update EOI instruments
            documentObj.file_uri = null;
            documentObj["show_file_url"] = null;
            documentObj.file = null;
        }
    }

    replaceEOIDocument(files, upload_type, document_kind, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let callback = self.uploadEOIDocument(files, documentObj, upload_type, document_kind);

        self.removeEOIDocument(documentObj, callback);
    }

    addPayment() {
        const self = this;

        let new_instrument = {};
        if (!self.SSEoiService.sale_obj.instruments) {
            self.SSEoiService.sale_obj.instruments = [];
        }
        self.SSEoiService.sale_obj.instruments.push(new_instrument);

        self.$timeout(function() { 
            $(".dashboard-select#relationship").niceSelect('update');
            $(".dashboard-select#documentUploadBank").niceSelect('update');
            $(".dashboard-select[id^=format]").niceSelect('update');
            $(".dashboard-select[id^=payment_type]").niceSelect('update');
            $(".datepicker").datepicker( { dateFormat: "yy-mm-dd" } );
        });
    }

    hideModals() {
        const self = this;

        self.showRemovePaymentModal = false;
        self.showRemoveDocumentModal = false;

        if ($('#removePaymentModal').is(':visible')) $('#removePaymentModal').modal('hide');
        if ($('#removeDocumentModal').is(':visible')) $('#removeDocumentModal').modal('hide');
    }

    removePayment(instrument) {
        const self = this;

        self.selected_instrument = instrument;

        self.hideModals();

        self.showRemovePaymentModal = true;
        $('#removePaymentModal').modal('show');
    }

    removePaymentObject(instrument) {
        const self = this;

        self.SSEoiService.sale_obj.instruments = self.SSEoiService.sale_obj.instruments.filter(item => item !== instrument);
        self.hideModals();
        self.SSAlertService.success('Success!', 'Payment successfully removed.');
    }

    confirmRemovePayment() {
        const self = this;

        if (self.selected_instrument.hasOwnProperty("id") && self.selected_instrument.id != null) {
            let url = 'sec/eois/' + self.SSEoiService.eoi.id + '/instruments/' + self.selected_instrument.id + '/delete';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                
                self.removePaymentObject(self.selected_instrument);
            });
        } else {
            self.removePaymentObject(self.selected_instrument);
        }
    }

    addDocument() {
        const self = this;

        let new_document = {};

        if (!self.SSEoiService.sale_obj.documents) {
            self.SSEoiService.sale_obj.documents = [];
        }

        self.SSEoiService.sale_obj.documents.push(new_document);

        self.$timeout(function() { 
            $(".dashboard-select[id^=format]").niceSelect('update');
        });
    }

    removeDocument(document) {
        const self = this;

        self.selected_document = document;

        self.hideModals();

        self.showRemoveDocumentModal = true;
        $('#removeDocumentModal').modal('show');
    }

    confirmRemoveDocument() {
        const self = this;

        if (self.selected_document.hasOwnProperty("id") && self.selected_document.id != null) {
            let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + self.selected_document.id + '/delete';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                
                self.removeDocumentObject(self.selected_document);
            });
        } else {
            self.removeDocumentObject(self.selected_document);
        }
    }

    removeDocumentObject(other_document) {
        const self = this;

        self.SSEoiService.sale_obj.documents = self.SSEoiService.sale_obj.documents.filter(item => item !== other_document);
        self.hideModals();
        self.SSAlertService.success('Success!', 'Other Document successfully removed.');
    }

    uploadOtherDocument(files, other_document, upload_type, document_kind) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {                
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            other_document['file_uri'] = response.config.data.key;
            other_document.file = file;
            self.SSEoiService.documentUploadDirty = true;
        });
    }

    removeOtherDocument(documentObj, callback) {
        const self = this;

        if (documentObj.hasOwnProperty("id") && documentObj.id != null) {
            let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + documentObj.id + '/delete';
            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.SSAlertService.success('Success!', 'File deleted successfully.');

                documentObj.id = null;
                documentObj.file_uri = null;
                documentObj["show_file_url"] = null;
                documentObj.file = null;

                callback;
            });
        } else {
            //Haven't update EOI instruments
            documentObj.file_uri = null;
            documentObj["show_file_url"] = null;
            documentObj.file = null;
        }
    }

    replaceOtherDocument(files, upload_type, document_kind, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let callback = self.uploadOtherDocument(files, documentObj, upload_type, document_kind);

        self.removeOtherDocument(documentObj, callback);
    }

    checkAccountHolderNameEmpty(instrument) {
        const self = this;

        if (instrument.account_holder_name_empty) {
            instrument.account_holder_name = "";
        }
    }

    proceedPDIPageCheckDirty() {
        const self = this;

        self.uploadSaleOtherDocument();

        if (self.SSEoiService.sale_obj.instruments && self.SSEoiService.sale_obj.instruments.length > 0) {
            self.uploadSaleInstrument(self.proceedSummaryPage);
        } else {
            self.proceedSummaryPage(self);
        }
    }

    proceedSummaryPage(self) {
        self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_SUMMARY_PAGE;
        self.SSAlertService.message = null;
        loading(false);
    }

    checkChequeAmount() {
        const self = this;

        let total_amount = 0;

        $.each(self.SSEoiService.sale_obj.instruments, function (index, instrument) {
            total_amount += parseFloat(instrument.amount);
        });

        if (total_amount < self.SSEoiService.payable_amount) {
            //Show warning message
            self.showAmountInsufficientModal();
            return false;
        } 

        return true;        
    }

    showAmountInsufficientModal() {
        const self = this;

        self.hideAmountInsufficientModal();

        self.showInsufficientAmountModal = true;

        $('#insufficientAmountModal').modal('show');
    }

    proceedAnywayAmountInsufficient() {
        const self = this;

        self.hideAmountInsufficientModal();
        self.proceedPDIPageCheckDirty();
    }

    hideAmountInsufficientModal() {
        const self = this;

        self.showInsufficientAmountModal = false;

        if ($('#insufficientAmountModal').is(':visible')) $('#insufficientAmountModal').modal('hide');
    }

    proceedToPDIPage() {
        const self = this;

        if (self.validateDocumentUpload()) {
            self.proceedPDIPageCheckDirty();
        }
    }

    checkDocumentUploadDirty() {
        const self = this;

        //Show warning message if cheque amount is less than 5% of purchase price
        if (self.checkChequeAmount()) {
            self.proceedPDIPageCheckDirty();
        }
    }

    validateIndividualDocument(individualObj) {
        const self = this;

        // All documents are optional, so COMMENTED this code [WEB-1062]
        // if (!individualObj.hasOwnProperty("documents")) {
        //     self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
        //     return false;
        // } 
        // else {
        //     if (individualObj.individual_identity_type == SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
        //         if (!individualObj.documents.hasOwnProperty(self.PROPERTY_DOCUMENT_KIND_PASSPORT) || 
        //             individualObj.documents[self.PROPERTY_DOCUMENT_KIND_PASSPORT] == null) {
        //             self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
        //             return false;
        //         }
        //     } else {
        //         if (!individualObj.documents.hasOwnProperty(self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT) || 
        //             !individualObj.documents.hasOwnProperty(self.PROPERTY_DOCUMENT_KIND_NRIC_BACK) || 
        //             individualObj.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT] == null || 
        //             individualObj.documents[self.PROPERTY_DOCUMENT_KIND_NRIC_BACK] == null) {
        //             self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
        //             return false;
        //         }
        //     }
        // }

        return true;
    }

    validateDocumentUpload() {
        const self = this;

        self.uploadDocumentError = {};

        // All document files are optional i.e. images/pdf etc [WEB-1062]
        // if (self.SSEoiService.buyers[0].type == SHOWSUITE.BUYER_TYPE_COMPANY) {
        //     //Check company documents
        //     if (!self.SSEoiService.buyers[0].hasOwnProperty("documents")) {
        //         self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
        //         return false;
        //     } else if (!self.SSEoiService.buyers[0].documents.hasOwnProperty(self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION) || self.SSEoiService.buyers[0].documents[self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION] == null) {
        //         self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
        //         return false;
        //     }

        //     //Check individual documents
        //     if (!self.validateIndividualDocument(self.SSEoiService.buyers[1])) {
        //         return false;
        //     }
        // } else {
        //     for (var i = 0; i < self.SSEoiService.buyers.length; i++) {
        //         //Check individual documents
        //         if (!self.validateIndividualDocument(self.SSEoiService.buyers[i])) {
        //             return false;
        //         }
        //     }
        // }

        //Check EOI document
        let document_error = false;
        $.each(self.SSEoiService.sale_obj.documents, function (index, other_document) {
            if (!other_document.hasOwnProperty("name") || other_document.name === "" || other_document.name === null) {
                self.SSAlertService.danger('Error!', 'Please enter name of supporting document.');
                document_error = true;
                return false;
            }

            if (!other_document.hasOwnProperty("format") || other_document.format === "" || other_document.format === null) {
                self.SSAlertService.danger('Error!', 'Please select type of supporting document.');
                document_error = true;
                return false;
            }

            // if (!other_document.hasOwnProperty("file_uri") && !other_document.hasOwnProperty("file")) {
            //     self.SSAlertService.danger('Error!', 'Please upload supporting document.');
            //     document_error = true;
            //     return false;
            // }
        });

        if (document_error) {
            return false;
        }

        //Check EOI instruments
        let instrument_error = false;
        if (!self.SSEoiService.sale_obj.hasOwnProperty("instruments")) {
            self.SSAlertService.danger('Error!', 'Please fill-in the valid information.');
            return false;
        } 
        else {
            $.each(self.SSEoiService.sale_obj.instruments, function (index, instrument) {
                // All document files are optional
                //  if (instrument.hasOwnProperty("type") 
                //     && (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CHEQUE 
                //     || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER 
                //     || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH)) {
                //     if (!instrument.hasOwnProperty("file_uri") || instrument.file_uri == null || instrument.file_uri === '') {
                //         self.SSAlertService.danger('Error!', 'Please upload mandatory documents.');
                //         instrument_error = true;
                //         return false;
                //     }
                // }

                if (instrument.hasOwnProperty("type") && (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CHEQUE || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD)) {
                    if (!instrument.hasOwnProperty("account_holder_name_empty") || instrument.account_holder_name_empty == false || instrument.account_holder_name_empty == null) {
                        if (!instrument.hasOwnProperty("account_holder_name") || instrument.account_holder_name == null || instrument.account_holder_name == "") {
                            self.uploadDocumentError["account_holder_name"] = "Please enter Name of Account Holder."
                        }
                    }
                }

                if (instrument.hasOwnProperty("type") && (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CHEQUE || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER)) {
                    if (!instrument.hasOwnProperty("cheque_date") || instrument.cheque_date == null) {
                        self.uploadDocumentError["cheque_date"] = "Please select Cheque Date."
                    } else {
                        if (instrument.hasOwnProperty("bank_in_date") && instrument.bank_in_date != null) {
                            let temp_bank_in_date = moment(instrument.bank_in_date, 'YYYY-MM-DD');
                            let temp_cheque_date = moment(instrument.cheque_date, 'YYYY-MM-DD');

                            if (temp_bank_in_date.isBefore(temp_cheque_date)) {
                                self.uploadDocumentError["bank_in_date"] = "Bank in date cannot be earlier than cheque date."
                            }
                        }
                    }
                }

                if (instrument.hasOwnProperty("type") && (instrument.type !== SHOWSUITE.INSTRUMENT_TYPE_CASH_IN)) {
                    if (!instrument.hasOwnProperty("bank_name") || instrument.bank_name == null || instrument.bank_name === '') {
                        self.uploadDocumentError["bank_name"] = "Please select Bank."
                    } else if (instrument.bank_name == 'OTHERS') {
                        if (!instrument.hasOwnProperty("bank_name_other") || instrument.bank_name_other == null || instrument.bank_name_other === '') {
                            self.uploadDocumentError["bank_name_other"] = "Please enter Other Bank Name."
                        }
                    }
                }

                if (!instrument.hasOwnProperty("type") || instrument.type == null) {
                    self.uploadDocumentError["type"] = "Please select Payment Type."
                }

                if (!instrument.hasOwnProperty("amount") || instrument.amount == null || instrument.amount === '') {
                    self.uploadDocumentError["amount"] = "Please enter Amount."
                }

                if (instrument.hasOwnProperty("type") && (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CHEQUE || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_GIRO)) {
                    if (!instrument.hasOwnProperty("instrument_no") || instrument.instrument_no == null || instrument.instrument_no == "") {
                        if (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CHEQUE) {
                            self.uploadDocumentError["instrument_no"] = "Please enter Cheque No."
                        }

                        if (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER) {
                            self.uploadDocumentError["instrument_no"] = "Please enter Cashiers' Order No."
                        }

                        if (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER || instrument.type === SHOWSUITE.INSTRUMENT_TYPE_GIRO) {
                            self.uploadDocumentError["instrument_no"] = "Please enter Transaction No."
                        }

                        if (instrument.type === SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD) {
                            self.uploadDocumentError["instrument_no"] = "Please enter Debit Card No."
                        }
                        
                    }
                }

                if (instrument.hasOwnProperty("relationshipCheck") && instrument.relationshipCheck == true) {
                    if (!instrument.hasOwnProperty("relationship") || instrument.relationship == null || instrument.relationship === '') {
                        self.uploadDocumentError["relationship"] = "Please select Relationship to the Buyer."
                    } else if (instrument.relationship == 'OTHERS') {
                        if (!instrument.hasOwnProperty("relationship_other") || instrument.relationship_other == null || instrument.relationship_other === '') {
                            self.uploadDocumentError["relationship_other"] = "Please enter Other Relationship to the Buyer."
                        }
                    }

                }

                if (!$.isEmptyObject(self.uploadDocumentError)) {
                    self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                    instrument_error = true;
                    return false;
                }
            });

            if (instrument_error) {
                return false;
            }
        }

        return true;
    }

    uploadSaleOtherDocument() {
        const self = this;

        let url = '';

        $.each(self.SSEoiService.sale_obj.documents, function (index, other_document) {
            let params = {
                name: other_document.name,
                type: self.PROPERTY_DOCUMENT_TYPE_FORM,
                format: other_document.format,
                document_kind: self.PROPERTY_DOCUMENT_KIND_OTHER,
                file_uri: other_document.file_uri
            };

            loading(true);
            if (other_document.hasOwnProperty("id") && other_document.id != null) {
                url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents/' + other_document.id;

                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    if (response instanceof Error) {
                        loading(false);
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if (!self.SSEoiService.sale_obj.hasOwnProperty("documents")) {
                        self.SSEoiService.sale_obj["documents"] = {};
                    }
                    other_document = response.data;

                    //Prepare preview image for documents
                    url = 'sec/assets/presigned-url';
                    params = {
                        'model': SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT,
                        'id': other_document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        loading(false);
                        if (response instanceof Error) {                            
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        other_document["show_file_url"] = response.data.presigned_url;
                        self.SSEoiService.sale_obj.documents[index] = other_document;
                    });
                });
            } else {
                url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/documents'

                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    if (response instanceof Error) {
                        loading(false);
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if (!self.SSEoiService.sale_obj.hasOwnProperty("documents")) {
                        self.SSEoiService.sale_obj["documents"] = {};
                    }
                    other_document = response.data.sale_document;

                    //Prepare preview image for documents
                    url = 'sec/assets/presigned-url';
                    params = {
                        'model': SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT,
                        'id': other_document.id
                    };
                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        loading(false);
                        if (response instanceof Error) {                            
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        other_document["show_file_url"] = response.data.presigned_url;
                        self.SSEoiService.sale_obj.documents[index] = other_document;
                    });
                });
            }
        });
    }

    uploadSaleInstrument(callback) {
        const self = this;

        if (self.SSEoiService.sale_obj.instruments && self.SSEoiService.sale_obj.instruments.length > 0) {
            if (!self.SSEoiService.sale_obj.payment) {
                //Create a new payment
                let url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/payments';
                let params = {
                    type: SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE,
                    status: SHOWSUITE.PAYMENT_STATUS_RECEIVED
                };

                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    if (response instanceof Error) {
                        loading(false);
                        // WEB-3674: the payment-save endpoint now returns the real
                        // rejection reason (WEB-3647), so surface it instead of the
                        // generic "Invalid Params!" toast for a 412.
                        self.SSAlertService.parseAndDisplayServerError(response);
                        return;
                    }

                    self.SSEoiService.sale_obj.payment = response.data.payment;

                    self.createSalePaymentInstrument(callback);
                });
            } else {
                self.createSalePaymentInstrument(callback);
            }
        }
    }

    createSalePaymentInstrument(callback) {
        const self = this;

        let url = '';
        let relationship = null;
        let bank_name = null;

        $.each(self.SSEoiService.sale_obj.instruments, function (index, instrument) {
            url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/payments/' + self.SSEoiService.sale_obj.payment.id + '/instruments';
            relationship = null;
            bank_name = null;
            if (instrument.hasOwnProperty("relationshipCheck") && instrument.relationshipCheck == true) {
                if (instrument.relationship == 'OTHERS') {
                    relationship = instrument.relationship_other;
                } else {
                    relationship = instrument.relationship;
                }
            }

            if (instrument.bank_name == 'OTHERS') {
                bank_name = instrument.bank_name_other;
            } else {
                bank_name = instrument.bank_name;
            }

            let params = {
                type: instrument.type,
                bank_name: bank_name,
                account_holder_name: instrument.account_holder_name,
                instrument_no: instrument.instrument_no,
                amount: self.getValidNumber(instrument.amount),
                relationship_with_account_holder: relationship,
                file_uri: instrument.file_uri,
                cheque_date: self.getFormattedDate(instrument.cheque_date),
                bank_in_date: self.getFormattedDate(instrument.bank_in_date)
            };

            loading(true);

            if (instrument.hasOwnProperty("id") && instrument.id != null) {
                url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id + '/payments/' + self.SSEoiService.sale_obj.payment.id + '/instruments/' + instrument.id;

                self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                    if (response instanceof Error) {
                        loading(false);
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if (!self.SSEoiService.sale_obj.hasOwnProperty("instruments")) {
                        self.SSEoiService.sale_obj["instruments"] = {};
                    }
                    instrument = response.data.payment.instruments.find(x => x.id == instrument.id);

                    //Prepare preview image for instruments
                    if (instrument.hasOwnProperty("file_uri") && instrument.file_uri != null && instrument.file_uri != "") {
                        url = 'sec/assets/presigned-url';
                        params = {
                            'model': SHOWSUITE.ASSET_MODEL_PAYMENT_INSTRUMENT,
                            'id': instrument.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            instrument["show_file_url"] = response.data.presigned_url;
                            self.SSEoiService.sale_obj.instruments[index] = instrument;
                        });
                    } else {
                        instrument["show_file_url"] = "";
                    }

                    if (index == self.SSEoiService.sale_obj.instruments.length - 1) {
                        callback(self);
                    }
                });
            } else {
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    if (response instanceof Error) {
                        loading(false);
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if (!self.SSEoiService.sale_obj.hasOwnProperty("instruments")) {
                        self.SSEoiService.sale_obj["instruments"] = {};
                    }
                    instrument = response.data.payment.instruments[response.data.payment.instruments.length - 1];

                    //Prepare preview image for instruments
                    if (instrument.hasOwnProperty("file_uri") && instrument.file_uri != null && instrument.file_uri != "") {
                        url = 'sec/assets/presigned-url';
                        params = {
                            'model': SHOWSUITE.ASSET_MODEL_PAYMENT_INSTRUMENT,
                            'id': instrument.id
                        };
                        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                            if (response instanceof Error) {
                                loading(false);
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                            }

                            instrument["show_file_url"] = response.data.presigned_url;
                            self.SSEoiService.sale_obj.instruments[index] = instrument;
                        });
                    } else {
                        instrument["show_file_url"] = "";
                    }

                    if (index == self.SSEoiService.sale_obj.instruments.length - 1) {
                        callback(self);
                    }
                });
            }
        });
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date != '' && date != null) {
                var now = new moment();
                var res = '';
                var _date =  '';

                // IF TIME IS ALSO THERE THEN SPLIT ONLY DATE PART
                if(date.includes(' ')){
                    date = date.split(" ")[0];
                }

                if(date.includes('/')){
                    res = date.split("/", 3);
                    _date = res[2] + '-' + res[1] + '-' + res[0] + ' ' + now.format("HH:mm:ss");
                }
                else if(date.includes('-')){
                    res = date.split("-", 3);
                    _date = res[0] + '-' + res[1] + '-' + res[2] + ' ' + now.format("HH:mm:ss");
                }

                if(!res || !_date){
                    return null;
                }

                var _localDate = new Date(self.parseDate(_date));
                var _utcFormat = moment(_localDate).utc().format('YYYY-MM-DD HH:mm:ss');

                return _utcFormat;
            }
            else{
                return null;
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    parseDate(date) {
        const self = this;
        
        const parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    getValidNumber(num){
        const self = this;

        if(!num) return;

        num = num.includes(',')? num.replace(',', '') : num;

        return num;
    }

}

SalesApplicationAddSaleDocumentUploadController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', '$timeout', 'SSEoiService', 'SSAwsService', 'SSAlertService', 'SSAppService'];
app.controller('SalesApplicationAddSaleDocumentUploadController', SalesApplicationAddSaleDocumentUploadController);
